module.exports = __webpack_public_path__ + "img/61800.c69232af.jpg";